import type { CheckoutBusService } from './bus'
import type { CheckoutCarRentalService } from './carRental'
import type { CheckoutClothingService } from './clothing'
import type { CheckoutLuggageService } from './luggage'
import type { CheckoutPerBookingService } from './perBooking'
import type { CheckoutPerParticipantService } from './perParticipant'
import type { CheckoutPerRoomService } from './perRoom'
import type { CheckoutBookingRedeemerService } from './redeemer'
import type { CheckoutSkiAncillaryService } from './ski'

export enum ServiceType {
  CarRental = 'carRental',
  CarRentalFiltering = 'carRentalFiltering',
  TravelInsurance = 'travelInsurance',
  TravelInsurancePerBooking = 'travelInsurancePerBooking',
  CancellationInsurance = 'cancellationInsurance',
  CancellationInsurancePerBooking = 'cancellationInsurancePerBooking',
  Bus = 'bus',
  MealplanDP = 'mealplanDP',
  Luggage = 'luggage',
  BookingRedeem = 'bookingRedeem',
  SkiPass = 'skiPass',
  SkiMaterial = 'skiMaterial',
  SkiLesson = 'skiLesson',
  Sweater = 'sweater',
  TShirt = 'tShirt',
  Golf = 'golf',
  DinnerVouchers = 'dinnerVouchers',
  Bridge = 'bridge',
  GenericServicePerBooking = 'genericServicePerBooking',
  GenericServicePerParticipant = 'genericServicePerParticipant',
  GenericServicePerRoom = 'genericServicePerRoom',
}

export interface CheckoutService {
  id: string
  isSelected: boolean
  type: ServiceType
}

export interface Services {
  [ServiceType.CarRental]: CheckoutCarRentalService
  [ServiceType.CarRentalFiltering]: CheckoutCarRentalService
  [ServiceType.TravelInsurance]: CheckoutPerParticipantService
  [ServiceType.TravelInsurancePerBooking]: CheckoutPerBookingService
  [ServiceType.CancellationInsurance]: CheckoutPerBookingService
  [ServiceType.CancellationInsurancePerBooking]: CheckoutPerBookingService
  [ServiceType.MealplanDP]: CheckoutPerRoomService
  [ServiceType.Luggage]: CheckoutLuggageService
  [ServiceType.BookingRedeem]: CheckoutBookingRedeemerService
  [ServiceType.SkiPass]: CheckoutSkiAncillaryService
  [ServiceType.SkiMaterial]: CheckoutSkiAncillaryService
  [ServiceType.SkiLesson]: CheckoutSkiAncillaryService
  [ServiceType.Sweater]: CheckoutClothingService
  [ServiceType.TShirt]: CheckoutClothingService
  [ServiceType.Bus]: CheckoutBusService
  [ServiceType.Golf]: CheckoutPerParticipantService
  [ServiceType.Bridge]: CheckoutPerParticipantService
  [ServiceType.DinnerVouchers]: CheckoutPerBookingService
  [ServiceType.GenericServicePerBooking]: CheckoutPerBookingService
  [ServiceType.GenericServicePerParticipant]: CheckoutPerParticipantService
  [ServiceType.GenericServicePerRoom]: CheckoutPerRoomService
}

export * from './bus'
export * from './carRental'
export * from './clothing'
export * from './common'
export * from './golf'
export * from './luggage'
export * from './perBooking'
export * from './perParticipant'
export * from './perRoom'
export * from './redeemer'
export * from './ski'
